import { Vector2 } from 'three';
import { LogicalSpace, Obstacle } from '@thive/fddm-types';

import { logger } from '@/modules/common/logging/logger';
import { Area } from '@/modules/floorplanDesign/types';

import { ICopyPasteService } from './ICopyPasteService';

export class CopyPasteServiceLogDecorator implements ICopyPasteService {
  private decoree: ICopyPasteService;

  constructor(decoree: ICopyPasteService) {
    this.decoree = decoree;
  }

  copyItem<T extends Area | LogicalSpace | Obstacle>(
    params:
      | {
          item: Area;
          type: 'Area';
          offset: Vector2;
        }
      | {
          item: LogicalSpace;
          type: 'LogicalSpace';
          offset: Vector2;
        }
      | {
          item: Obstacle;
          type: 'Obstacle';
          offset: Vector2;
        },
  ): T {
    const start = this.logStart('copyItem');
    const result = this.decoree.copyItem(params);
    this.logEnd('copyItem', start);
    return result as T;
  }

  copyToMemory(ids: string[]): void {
    const start = this.logStart('copyToMemory');
    this.decoree.copyToMemory(ids);
    this.logEnd('copyToMemory', start);
  }

  copySelectionToMemory(): void {
    const start = this.logStart('copySelectionToMemory');
    this.decoree.copySelectionToMemory();
    this.logEnd('copySelectionToMemory', start);
  }

  pasteFromMemory(canvasDestination?: Vector2 | null): void {
    const start = this.logStart('pasteFromMemory');
    this.decoree.pasteFromMemory(canvasDestination);
    this.logEnd('pasteFromMemory', start);
  }

  duplicateSelection(): void {
    const start = this.logStart('duplicateSelection');
    this.decoree.duplicateSelection();
    this.logEnd('duplicateSelection', start);
  }

  // private utility methods

  private logStart(methodName: string): number {
    const start: number = performance.now();
    logger.info(`Start -> ${methodName}`);
    return start;
  }

  private logEnd(methodName: string, start: number): void {
    logger.info(`End -> ${methodName} (${(performance.now() - start).toFixed(2)}ms)`);
  }
}
